import { render, staticRenderFns } from "./QuotationPdf.vue?vue&type=template&id=b1e116bc&scoped=true"
import script from "./QuotationPdf.vue?vue&type=script&lang=ts"
export * from "./QuotationPdf.vue?vue&type=script&lang=ts"
import style0 from "./QuotationPdf.vue?vue&type=style&index=0&id=b1e116bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e116bc",
  null
  
)

export default component.exports